module.exports = __webpack_public_path__ + "img/ibox@2x.png";